import { FileText, Download, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

const REPORTS = [
    {
        name: "Highway Bypass — Phase II Analysis",
        date: "12 Feb 2026",
        size: "1.2 MB",
        tag: "Full Report",
    },
    {
        name: "Medical Equipment Supply Analysis",
        date: "10 Feb 2026",
        size: "880 KB",
        tag: "Full Report",
    },
    {
        name: "Solar AMC Contract Analysis",
        date: "08 Feb 2026",
        size: "1.5 MB",
        tag: "Full Report",
    },
    {
        name: "Office Furniture Procurement Analysis",
        date: "05 Feb 2026",
        size: "640 KB",
        tag: "Full Report",
    },
    {
        name: "Smart City Surveillance Analysis",
        date: "02 Feb 2026",
        size: "2.1 MB",
        tag: "Full Report",
    },
    {
        name: "Govt. School Buildings — Cluster A",
        date: "29 Jan 2026",
        size: "1.1 MB",
        tag: "Full Report",
    },
];

export default function Reports() {
    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 dark:text-slate-50">
                    Reports
                </h1>
                <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">
                    Downloadable PDF reports for every tender you&apos;ve analyzed.
                </p>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {REPORTS.map((r) => (
                    <div
                        key={r.name}
                        className="rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-5 hover:shadow-md transition-shadow"
                    >
                        <div className="flex items-start justify-between">
                            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-indigo-50 dark:bg-indigo-950/40">
                                <FileText className="h-5 w-5 text-indigo-600" />
                            </div>
                            <Badge
                                variant="outline"
                                className="text-xs border-slate-200 dark:border-slate-700"
                            >
                                {r.tag}
                            </Badge>
                        </div>
                        <h3 className="mt-4 font-semibold text-sm text-slate-900 dark:text-slate-50 leading-snug min-h-[40px]">
                            {r.name}
                        </h3>
                        <div className="mt-3 flex items-center justify-between text-xs text-slate-500">
                            <span className="flex items-center gap-1">
                                <Calendar className="h-3 w-3" /> {r.date}
                            </span>
                            <span className="font-mono">{r.size}</span>
                        </div>
                        <Button
                            className="mt-5 w-full bg-slate-900 hover:bg-slate-800 dark:bg-white dark:hover:bg-slate-100 dark:text-slate-900 text-white"
                            size="sm"
                        >
                            <Download className="h-4 w-4 mr-2" /> Download
                        </Button>
                    </div>
                ))}
            </div>
        </div>
    );
}
